import { Component, OnInit, OnDestroy } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { environment } from 'environments/environment';
import { CoreTaskDataService } from '../core-task-data.service';
import { Subscription } from 'rxjs/Subscription';
import { AuthService } from '../../auth.service';
import { BreadcrumbService } from 'app/breadcrumb/breadcrumb.service';

@Component({
    selector: 'app-result',
    templateUrl: './result.component.html',
    styleUrls: ['./result.component.scss']
})
export class ResultComponent implements OnInit, OnDestroy {

    public source: object;
    public coreTaskId: string;
    private signaturePostSuccessSubscription: Subscription;
    private routeSubscription: Subscription;


    constructor(private breadcrumbService: BreadcrumbService, private route: ActivatedRoute,
        private coreTaskDataService: CoreTaskDataService, private auth: AuthService) { }

    ngOnInit() {
        this.routeSubscription = this.route.parent.params.subscribe(data => {
            this.coreTaskId = data['examinationId'];
            this.source = {
                url: `${environment.api}/kerntaken/${this.coreTaskId}/pdf/gevuld`,
                httpHeaders: {
                    Authorization: `Bearer ${this.auth.getToken()}`
                }
            }
        });
        this.breadcrumbService.workProcessCode = 'Resultaat';

        this.signaturePostSuccessSubscription = this.coreTaskDataService.signaturePostSuccess$.subscribe(() => {
            this.source = {
                url: `${environment.api}/kerntaken/${this.coreTaskId}/pdf/gevuld?ts=${Date.now()}`,
                httpHeaders: {
                    Authorization: `Bearer ${this.auth.getToken()}`
                }
            }
        });
    }

    ngOnDestroy(): void {
        this.routeSubscription.unsubscribe();
        this.signaturePostSuccessSubscription.unsubscribe();
    }

}



// WEBPACK FOOTER //
// ./src/app/examination/result/result.component.ts